import React from 'react';
import ROUTES from '../../constants/routes';
import { Link } from 'react-router-dom';
import Footer from '../../components/Footer';

const TermsAndConditionsPage = () => {
  return (
    <>
      <div className="container mx-auto max-w-3xl pt-6 pb-16 px-8">
        <Link to={ROUTES.homePage}>
          <img
            className="h-10 md:h-12 lg:h-16 max-w-xs object-contain hidden md:inline-block object-left"
            src={require('assets/images/gw-logo-blue-horizontal.png')}
            alt="Goodwork.ph"
          />
        </Link>
        <div className="my-10">
          <h1 className="text-goodwork-navyblue text-2xl md:text-3xl font-semibold leading-tight mb-6 text-center md:text-left">
            GoodWorkPH Terms and Conditions
          </h1>

          <p className="my-2 lg:text-lg">
            Welcome to the GoodWork.ph Platform (&quot;Platform&quot;) run by
            GoodWork Solutions Inc. Please use these Terms and Conditions to
            make an informed decision about whether to use this Platform. By
            accessing or otherwise interacting with our servers, services,
            websites, or any associated content/postings, you agree to these
            Terms of Use (&quot;TOU&quot;) (last updated November 25, 2020). The
            Platform is a private site owned and operated by GoodWork Solutions
            Inc. (“GoodWork”). Our
            <Link
              to={ROUTES.privacyPolicyPage}
              className="no-underline hover:underline text-blue-500"
            >
              {' '}
              privacy policy
            </Link>
            , prohibited services list at the end of this document, and all
            other policies, site rules, and agreements referenced below or on
            the Platform are fully incorporated into this TOU, and by continuing
            use, you acknowledge that you agree to them as well.
          </p>
        </div>
        <div className="my-10">
          <h3 className="text-goodwork-navyblue text-lg font-semibold leading-tight">
            DEFINITIONS
          </h3>
          <p className="my-2 lg:text-lg">
            <b>Service Partner:</b> A business or individual that has an account
            with GoodWork to offer services to customers through our Platform.
            Synonyms include Service Professional and Service Provider. For
            purposes of this TOU, a “business” includes a sole proprietorship,
            partnership or corporation registered by the relevant government
            agency.
          </p>
          <p className="my-2 lg:text-lg">
            <b>Customer:</b> An individual or business that has an account with
            GoodWork to discover Service Providers or Service Partners they can
            hire to undertake a specific service or task. These users are not
            considered Customers of GoodWork for the specific service or task;
            they are prospective Customers of Service Partners.
          </p>
          <p className="my-2 lg:text-lg">
            Customers and Service Partners are collectively referred to as
            “Users”.
          </p>
          <p className="my-2 lg:text-lg">
            <b>Platform:</b> The GoodWork website and mobile application that
            connects Customers to Service Partners in order to help Customers
            get a service performed or completed, and to help Service Partners
            find new Customers.
          </p>
          <p className="my-2 lg:text-lg">
            <b>Job Request:</b> A request initiated by a Customer on the
            Platform by inputting the following details: the type of service
            required, the schedule requested for the job, the location of the
            job, and any other specifics required in the service request. This
            request is then sent to relevant Service Partners on the Platform.
          </p>
          <p className="my-2 lg:text-lg">
            <b>Services:</b> Services are the types of work that are offered on
            the Platform to be performed by our Service Partners. Customers can
            look for the type of Service they need and connect with a Service
            Partner that can provide the required type of work. Synonyms
            includes Jobs and Projects.
          </p>
        </div>
        <div className="my-10">
          <h3 className="text-goodwork-navyblue text-lg font-semibold leading-tight">
            General use of and access to the Platform
          </h3>
          <p className="my-2 lg:text-lg">
            Guidelines to the use of Platform and Services: You agree to comply
            with any and all the guidelines, notices, operating rules and
            policies and instructions pertaining to the use of the services and
            access to the Platform, as well as any amendments to the
            aforementioned, issued by us from time to time. We reserve the right
            to revise these TOUs, guidelines, notices, operating rules and
            policies and instructions at any time and you are deemed to be aware
            of, and bound by, any changes to the foregoing upon their
            publication on the Platform.
          </p>
          <p className="my-2 lg:text-lg">
            You represent and warrant that, if you are registering for the use
            of the Platform as an individual, you are at least eighteen (18)
            years old; and if you are registering for the use of the Platform
            for and on behalf of an entity, you are authorized to enter into and
            bind the entity to these TOUs. We reserve the right, at our sole
            discretion, to refuse to offer the use of the services and the
            Platform to any person or entity and to change our eligibility
            criteria at any time. You may not create or use any account with us
            for any person or entity other than yourself except if you are
            authorized to do so for and on behalf of such person or entity.
          </p>

          <p className="mt-4 mb-2 mx-4">
            <b>Restricted activities:</b> You agree and undertake NOT to:
          </p>
          <ul className="list-disc mx-8">
            <li className="my-2 lg:text-lg">
              impersonate any person or entity, or falsely state or otherwise
              misrepresent your affiliation with any person or entity;
            </li>
            <li className="my-2 lg:text-lg">
              use the Platform to offer and procure the Services for illegal
              purposes;
            </li>
            <li className="my-2 lg:text-lg">
              attempt to gain unauthorized access to or otherwise interfere with
              or disrupt other computer systems or networks connected to the
              Platform or related services;
            </li>
            <li className="my-2 lg:text-lg">
              interfere with another’s use and enjoyment of the Platform or
              related services;
            </li>
            <li className="my-2 lg:text-lg">
              use or upload, in any way, any software or material that contains,
              or which you have reason to suspect that contains, viruses,
              damaging components, malicious code or harmful components which
              may impair or corrupt the Platform’s data or damage or interfere
              with the operation of another Customer’s computer or mobile device
              or the Platform or related services; and
            </li>
            <li className="my-2 lg:text-lg">
              use the Platform or related service other than in conformance with
              the acceptable use policies of any connected computer networks,
              any applicable Internet standards and any other applicable laws.
            </li>
          </ul>
          <p className="my-2 lg:text-lg">
            Availability of Platform and related service: We may, from time to
            time and without giving any reason or prior notice, upgrade, modify,
            suspend or discontinue the provision of or remove, whether in whole
            or in part, the Platform or any of the related services and shall
            not be liable if any such upgrade, modification, suspension or
            removal prevents you from accessing the Platform or any of the
            related services. GoodWork does not warrant that the
          </p>
          <p className="my-2 lg:text-lg">
            functions contained in the services provided by the Platform and the
            GoodWork.ph website will be uninterrupted or error-free, that
            defects will be corrected or that this service or the server that
            makes it available will be free of viruses or other harmful
            components.
          </p>
          <p className="my-2 lg:text-lg">
            GoodWork retains the right, but not the obligation, to monitor
            content: We reserve the right, but shall not be obliged to:
          </p>

          <div className="mx-8">
            <li className="my-2 lg:text-lg">
              monitor, screen or otherwise control any activity, content or
              material on the Platform. We may in our sole and absolute
              discretion, investigate any violation of the terms and conditions
              contained herein and may take any action we deem appropriate;
            </li>
            <li className="my-2 lg:text-lg">
              prevent or restrict access of any Customer or Service Partner to
              the Platform;
            </li>
            <li className="my-2 lg:text-lg">
              report any activity we suspect to be in violation of any
              applicable law, statute or regulation to the appropriate
              authorities and to cooperate with such authorities; and
            </li>
            <li className="my-2 lg:text-lg">
              to request any information and data from you in connection with
              your use of our services and access to the Platform at any time
              and to exercise our rights under this paragraph if you refuse to
              divulge such information or data, or if you have provided, or if
              we have reasonable grounds to suspect that you have provided,
              inaccurate, misleading or fraudulent information or data.
            </li>
          </div>
          <p className="my-2 lg:text-lg">
            You acknowledge and agree that your only remedy against GoodWork
            with respect to any problems or dissatisfaction with the Services is
            to request for termination of your account and/or discontinue any
            use of the Platform services.
          </p>
          <p className="my-2 lg:text-lg">
            GoodWork reserves all rights not expressly granted herein.
          </p>
          <p className="my-2 lg:text-lg">
            Nothing in these TOUs shall constitute a formal partnership, joint
            venture or principal-agent relationship between you and GoodWork,
            nor does it authorize you to incur any costs or liabilities on
            GoodWork’s behalf.
          </p>
          <p className="my-2 lg:text-lg">
            We do not warrant that the materials on the Platform are appropriate
            or available for use in locations outside the Philippines. Accessing
            the website from territories where its contents are illegal or
            unlawful is prohibited. If you choose to access the website from
            elsewhere, you do so on your own initiative and are responsible for
            compliance with local laws.
          </p>
        </div>
        <div className="my-10">
          <h3 className="text-goodwork-navyblue text-lg font-normal leading-tight">
            1.1 For Customers:
          </h3>
          <p className="my-2 lg:text-lg">
            1.1.1 Please read these terms and conditions before you request a
            service on the GoodWork Platform. Any person who uses our Platform
            to communicate with or book a Service Partner will be subject to the
            terms and conditions defined here. If you do not agree with these
            terms, you should not use this Platform or discontinue its use
            immediately.
          </p>
          <p className="my-2 lg:text-lg">
            1.1.2 GoodWork operates a Platform where Service Partners can post
            their respective business information and where Customers can post
            Job Requests for Services they require. The Platform enables
            Customers and Service Partners to be introduced online in order to
            potentially agree to perform the Service that the Customer requires.
            <b>
              GoodWork is not responsible to the Customer for the performance of
              the Services that are provided by the Service Partner even if the
              Introduction was made on the Platform.
            </b>
          </p>
          <p className="my-2 lg:text-lg">
            1.1.3 From time to time, we update these Customer Terms. Every time
            you post a Job Request on the Platform you agree to the latest
            version of the terms. Please check these terms before posting a Job
            Request to make sure that you understand the most recent version of
            the Terms.
          </p>
          <p className="my-2 lg:text-lg">
            1.1.4 If you have any questions about the terms, please message us
            on Facebook Messenger at{' '}
            <a
              className="no-underline hover:underline text-blue-500"
              href="https://www.facebook.com/Goodwork.ph/"
            >
              facebook.com/GoodWork.ph
            </a>
            .
          </p>
        </div>
        <div className="my-10">
          <h3 className="text-goodwork-navyblue text-lg font-normal leading-tight">
            1.2 Registering on the Platform
          </h3>
          <p className="my-2 lg:text-lg">
            1.2.1 From the GoodWork homepage, internet users may be able to
            request a service directly on the GoodWork.ph website. To use the
            GoodWork.ph customer app, users must register to create a free user
            account. Users can register with their mobile phone number or with
            their Facebook account.
          </p>
          <p className="my-2 lg:text-lg">
            1.2.2 After a Service Partner performs a Service or Job for a
            Customer, the Customer will have the opportunity to rate the Service
            Partner. The Service Partner may also be invited to give a rating of
            the Customer. GoodWork may publish this rating of the Customer on
            the Customer profile for Service Partners to see. As such, this
            rating may impact the degree to which Service Partners will engage
            with a Customer in the future. GoodWork also reserves the right to
            temporarily suspend or permanently remove a Customer account from
            the Platform based on this rating score (or for any other valid
            reason).
          </p>
        </div>
        <div className="my-10">
          <h3 className="text-goodwork-navyblue text-lg font-normal leading-tight">
            1.3 Booking a Service
          </h3>
          <p className="my-2 lg:text-lg">
            1.3.1 After a Customer has completed and submitted the Job Request
            to the Platform, some GoodWork Service Partners that provide the
            Services indicated in the Job Request (as determined by GoodWork)
            will receive a notification of the Job Request. They will be told
            the type of Service and the details that were included in the Job
            Request.
          </p>
          <p className="my-2 lg:text-lg">
            1.3.2 One of the Service Partners may elect to accept your service
            request. Whichever Service Partner accepts the Job Request first
            will reserve this job for their account. A Customer can always elect
            to cancel a Job Request or a confirmed service if they would like to
            cancel the Service.
          </p>
          <p className="my-2 lg:text-lg">
            1.3.3 Depending on the type of Service, the price of the Service may
            be set by GoodWork or it may be open to negotiation between the
            Customer and the Service Provider. If the price is set by GoodWork,
            this price will be displayed during the booking request.
          </p>
          <p className="my-2 lg:text-lg">
            1.3.4 We offer no guarantee that there will be any Service Partners
            that accept a particular Job Request.
          </p>
          <p className="my-2 lg:text-lg">
            1.3.5 GoodWork reserves the right to read and review messages
            between Service Partners and Customers on the Platform.
          </p>
          <p className="my-2 lg:text-lg">
            1.3.6 Anyone using our services assumes full responsibility of their
            medical/health condition. All customers must know their own
            limitations and assumes all risks associated with any of our
            Services. Our Service Providers are not trained to diagnose, examine
            or treat any medical conditions of any sort and any
            comments/suggestions should not be construed as being medically
            appropriate. It is the responsibility of each Customer to consult
            with their medical professional to determine if they have any
            medical conditions.
          </p>
        </div>
        <div className="my-10">
          <h3 className="text-goodwork-navyblue text-lg font-normal leading-tight">
            1.4 Partner Information:
          </h3>
          <p className="my-2 lg:text-lg">
            1.4.1 The Service Partners have agreed to only post accurate
            information about their Services, credentials and other relevant
            information on their GoodWork profile. It is the Service Partner’s
            responsibility to make sure that this information is accurate.
            GoodWork does not have any responsibility for the accuracy of any
            claims made by Service Partners on their profiles or anywhere else
            on the Platform including in messages or other communication to
            Customers.
          </p>
          <p className="my-2 lg:text-lg">
            1.4.2 It is the Customer’s responsibility to make clear to the
            Service Partner regarding any unusual circumstances or special needs
            that may impact or impede the Service Partner’s ability to perform
            the agreed Job. If you fail to disclose this information in advance,
            neither GoodWork nor the relevant Service Partner will be liable to
            you for any injury, loss or damages resulting from the Job that
            could have been reasonably avoided had these circumstances been made
            clear in advance of the work commencing.
          </p>
        </div>
        <div className="my-10">
          <h3 className="text-goodwork-navyblue text-lg font-normal leading-tight">
            1.5 Payment:
          </h3>
          <p className="my-2 lg:text-lg">
            1.5.1 Payment for Jobs should be made in cash, or by other means,
            directly to the Service Partner.
          </p>
          <p className="my-2 lg:text-lg">
            1.5.2 VAT payments, other fees and the issuance of the invoice and
            receipt is the responsibility of the Service Partner. GoodWork is
            not legally allowed to issue an invoice on behalf of any third-party
            Service Partners.
          </p>
        </div>
        <div className="my-10">
          <h3 className="text-goodwork-navyblue text-lg font-normal leading-tight">
            1.6 Resolving issues:
          </h3>
          <p className="my-2 lg:text-lg">
            1.6.1 We want our Customers and Service Partners to both have a
            positive experience using the Platform. If a Customer has any
            concerns about a Service Partner or the work performed by a Service
            Partner, Customers can reach out to GoodWork on the GoodWork
            Facebook Messenger page at Facebook.com/GoodWork.ph. We will try to
            assist to mediate and resolve any issues that arise. We recommend
            that Customers first try to solve any issues directly with the
            Service Partner. If the issue cannot be resolved directly, then the
            Customer can leave a review of the Service Partner on the Platform.
            If necessary, Customers and Service Partners are welcome to reach
            out to GoodWork directly for assistance. GoodWork reserves the right
            to edit or delete a customer review if we deem the information to be
            inaccurate, outdated, profane, or otherwise inappropriate. To be
            clear, GoodWork is not responsible for the work provided by any
            third-party Service Partner.
            <b>
              If the Customer is dissatisfied for any reason, GoodWork will
              assist as much as possible, but we are under no obligation to
              provide a refund and we are not liable for any claims for damages
              or otherwise.
            </b>
          </p>
        </div>
        <div className="my-10">
          <h3 className="text-goodwork-navyblue text-lg font-normal leading-tight">
            1.7 General:
          </h3>
          <p className="my-2 lg:text-lg">
            1.7.1 If any of these terms are deemed to be unlawful or
            unenforceable, this will not negate the rest of the Agreement – the
            rest of the Agreement will remain in effect.
          </p>
        </div>
        <div className="my-10">
          <h3 className="text-goodwork-navyblue text-lg font-normal leading-tight">
            2.1 For Service Partners
          </h3>
          <p className="my-2 lg:text-lg">
            2.1.1 Before you begin to use our Platform, please carefully read
            this TOU as these terms and conditions will apply to your
            relationship and activities with GoodWork and the Customers. We
            recommend that you also read the Customer Terms Agreement. If you do
            not agree with this TOU, you should not use the Platform and you
            should not provide Services to the Customers.
          </p>
          <p className="my-2 lg:text-lg">
            2.1.2 We expect we may need to update or amend this TOU from time to
            time in the future to comply with applicable laws or regulations or
            to meet our changing needs as a business.
          </p>
          <p className="my-2 lg:text-lg">
            2.1.3 We will inform Service Partners using our Platform if we make
            changes to this TOU in the future. Such changes shall be effective
            immediately after such posting. If the change is immaterial in
            nature, we may not request your specific approval of the amended
            TOU.
          </p>
          <p className="my-2 lg:text-lg">
            2.1.4 If you continue to use the Platform, you agree to be bound by
            the terms of any updates and amendments implemented as described in
            clause 2. Any Job that has already been accepted by the Customer
            before the change or amendment is made will not be impacted by the
            change.
          </p>
          <p className="my-2 lg:text-lg">
            2.1.5 For all Jobs, GoodWork is acting as the operator and
            administrator of the Website and the App. The Service Partner
            remains fully responsible and liable for the provisioning of
            Services to Customers. Service Partners understand and agree that
            they are clients of GoodWork, and are not its employees, joint
            venturers, partners, or agents. Service Partners acknowledge that
            they provide their own equipment, and determine their own work
            schedule.
          </p>
        </div>
        <div className="my-10">
          <h3 className="text-goodwork-navyblue text-lg font-normal leading-tight">
            2.2 Partner Account
          </h3>
          <p className="my-2 lg:text-lg">
            2.2.1 You will be asked to confirm the terms of this TOU as part of
            the sign-up registration process on our Website and the App. After
            successfully registering, you will be given an online account on the
            Platform. This account will allow you to respond to Job Requests
            from Customers and to keep track of your activity on the Platform.
          </p>
          <p className="my-2 lg:text-lg">
            2.2.2 The sign-up registration process will require a verification
            process. For individual accounts, you need to upload a photo of a
            valid and existing Government ID card, and you need to upload a
            photo of your updated NBI clearance. For companies with a Business
            Account, you need to upload a photo of one of the following: (a)
            Department of Trade and Industry or Securities and Exchange
            Commission registration papers; (b) local government registration
            papers; and (c) other documents that GoodWork determines would be
            relevant in providing information to GoodWork and the Customer of
            your qualifications in connection with providing the Services.
          </p>
          <p className="my-2 lg:text-lg">
            2.2.3 The registration process also requires that you verify your
            mobile phone number or email address. GoodWork will send you a text
            message or email to confirm that this is your accurate number or
            email address.
          </p>
        </div>
        <div className="my-10">
          <h3 className="text-goodwork-navyblue text-lg font-normal leading-tight">
            2.3 Introduction Rates
          </h3>
          <p className="my-2 lg:text-lg">
            2.3.1 GoodWork reserves the right to introduce a fee for using the
            GoodWork Platform. This fee may be a monthly subscription fee, a
            commission or fee per Service, or any other type of fee structure.
          </p>
        </div>
        <div className="my-10">
          <h3 className="text-goodwork-navyblue text-lg font-normal leading-tight">
            2.4 Receiving Jobs
          </h3>
          <p className="my-2 lg:text-lg">
            2.4.1 Customers will submit Job Requests for Jobs to be completed by
            a Service Partner. The Service Partner on the Platform will see
            these Job Requests on their dashboard and have the ability to accept
            the Job. The Job Request will provide the type of Service requested,
            the location of the Customer, and the date and time that the
            Customer would like the Job to be completed.
          </p>
          <p className="my-2 lg:text-lg">
            2.4.2 There is no guarantee that a Service Partner will be able to
            receive any specific Job Request. The first Service Partner to
            confirm a Job Request will reserve this Job for their account and no
            other Service Partner will be able to take this job.
          </p>
          <p className="my-2 lg:text-lg">
            2.4.3 The Customer is allowed to cancel a Job Request at any time,
            even after a Job has been confirmed by a Service Partner.
          </p>
          <p className="my-2 lg:text-lg">
            2.4.4 GoodWork reserves the right to reduce the number of Job
            Requests that a Service Partner can see, or to remove a Service
            Partner entirely, from the Platform. GoodWork may decide to reduce
            or remove a Service Partner’s exposure on the Platform based on the
            Service Partner’s history of performance on the Platform, Customer
            Ratings or other performance indicators. Service Partners can also
            be removed if there is sufficient information showing that they have
            violated any terms and conditions of GoodWork, or committed a
            violation of any applicable laws.
          </p>
          <p className="my-2 lg:text-lg">
            2.4.5 The Service Partner is solely responsible for including VAT
            and any other government taxes, fees, and tariffs (if any) in their
            Price Quotes. It is the Service Partner’s responsibility to collect
            and pay VAT and other applicable taxes. and the Service Partner is
            liable for any inaccuracies or incomplete VAT or tax payments.
          </p>
        </div>
        <div className="my-10">
          <h3 className="text-goodwork-navyblue text-lg font-normal leading-tight">
            2.5 Service Partner Obligations
          </h3>
          <p className="my-2 lg:text-lg">
            2.5.1 The Service Partner must comply with any and all applicable
            laws relating to the provision of the Services.
          </p>
          <p className="my-2 lg:text-lg">
            2.5.2 The Service Partner is responsible for the accuracy of any
            statements, claims, or images uploaded to their profile or sent as a
            message to a Customer. The Service Partner must always ensure that
            they have the right to use or appropriate any photographs or images
            that they submit to the Platform.
          </p>
          <p className="my-2 lg:text-lg">
            2.5.3 If the Service Partner has their own terms or conditions, it
            is the Service Partner’s responsibility to get approval from the
            Customer for these terms. If there is any discrepancy or
            contradiction between the Platform TOU and the Service Partner’s
            terms, as between GoodWork and the Service Partner, this TOU will
            take precedence.
          </p>
          <p className="my-2 lg:text-lg">
            2.5.4 The Service Partner should not send Customers offers for
            additional or future jobs outside of the GoodWork Platform. All
            current and future services between a Customer and a GoodWork
            Partner should occur on the GoodWork platform. GoodWork reserves the
            right to ban the Service Partner from using the Platform and to sue
            the Service Partner for damages for violation of this clause.
          </p>
        </div>
        <div className="my-10">
          <h3 className="text-goodwork-navyblue text-lg font-normal leading-tight">
            2.6 Customer Service and Complaints
          </h3>
          <p className="my-2 lg:text-lg">
            2.6.1 Service Partners should do everything in their power to
            provide the best possible service experience to all Customers.
            Service Partners should respond to Customer concerns and questions
            as quickly as possible.
          </p>
          <p className="my-2 lg:text-lg">
            2.6.2 The Service Partner is directly responsible to the Customer
            for any liability that arises due to a Job.
          </p>
          <p className="my-2 lg:text-lg">
            2.6.3 GoodWork will refer Customer complaints to the Service Partner
            and the Service Partner is expected to respond to all complaints
            within 48 hours after receiving the complaint (regardless if the
            complaint comes directly from the Customer or if the complaint comes
            from GoodWork).
          </p>
          <p className="my-2 lg:text-lg">
            2.6.4 For any ongoing discussions to resolve Customer complaints,
            these messages should be conducted on the Platform through the
            messaging function. If the messages are not on the Platform, it is
            less likely that GoodWork can assist to resolve the issue.
          </p>
          <p className="my-2 lg:text-lg">
            2.6.5 The Service Partner acknowledges and accepts that the GoodWork
            Platform enables and encourages Customers to write reviews about
            their experience with the Service Partner. These reviews are
            publicly posted on the profile page of the Service Partner on the
            Platform. These reviews may be both positive and negative in nature
            and prospective new Customers will be able to view these reviews. If
            the customer review is deemed by GoodWork to be threatening,
            inappropriate in nature, or no longer relevant, GoodWork may delete
            the review or ask the Customer to edit the contents. For clarity,
            the Service Partner has no right to any monetary or non-monetary
            compensation (including the right to terminate this Agreement) as a
            result of any Customer review on the Platform.
          </p>
        </div>
        <div className="my-10">
          <h3 className="text-goodwork-navyblue text-lg font-normal leading-tight">
            2.7 Partner Content for Platform; Intellectual Property Rights
          </h3>
          <p className="my-2 lg:text-lg">
            2.7.1 The Service Partner acknowledges that all content the Service
            Partner submits for the Platform is lawful, not defamatory, not
            threatening, and not pornographic. Additionally, the Service Partner
            grants GoodWork the right to use this content on the Platform and
            potentially, and from time to time, for advertising efforts of
            GoodWork on other online platforms and offline channels. GoodWork
            may also incorporate aspects of the Service Partner’s content in our
            search engine optimization efforts.
          </p>
          <p className="my-2 lg:text-lg">
            2.7.2 It is the Service Partner’s responsibility to comply with all
            relevant laws, regulations and codes of conduct that pertain to both
            the marketing and performance of the Services.
          </p>
          <p className="my-2 lg:text-lg">
            2.7.3 You grant us a non-exclusive license to use the materials and
            information that you submit to the Platform, including but not
            limited to, business information, photographs, and location
            information. GoodWork may use this information for marketing
            purposes on or off-site channels including, but not limited to, for
            Platform advertisements on Facebook or through other channels.
          </p>
          <p className="my-2 lg:text-lg">
            2.7.4 Apart from the content submitted by the Service Partner, all
            other content and intellectual Property on the Platform remain the
            sole property of GoodWork.
          </p>
        </div>
        <div className="my-10">
          <h3 className="text-goodwork-navyblue text-lg font-normal leading-tight">
            2.8 Service Partner’s Liability
          </h3>
          <p className="my-2 lg:text-lg">
            2.8.1 The Service Partner shall indemnify, keep indemnified and hold
            GoodWork free and harmless and its officers, agents, directors and
            employees, from and against any and all claims, injuries, demands,
            obligations, actual or alleged causes of action and lawsuits and all
            damages, liabilities, fines, judgments, costs (including settlement
            costs), expenses associated therewith (including the payment of
            reasonable legal charges and disbursements) and losses (including
            but not limited to any direct, indirect or consequential losses,
            loss of profit, loss of reputation and all interest, penalties and
            legal costs (calculated on a full indemnity basis)) and all other
            reasonable professional costs and expenses arising out of, or in
            connection with, any breach by the Service Partner of any term of
            this TOU and any other agreement, or arising out of any action
            brought by any third party relating to the Services provided (or not
            provided), or actions (or failure to act), of the Service Partner or
            any person (other than GoodWork) acting on its behalf, including,
            without limitation any action brought in connection with any data
            protection legislation.
          </p>
          <p className="my-2 lg:text-lg">
            2.8.2 This clause shall survive the termination or expiry of any
            agreement with the Users.
          </p>
        </div>
        <div className="my-10">
          <h3 className="text-goodwork-navyblue text-lg font-normal leading-tight">
            2.9 Term of Agreement
          </h3>
          <p className="my-2 lg:text-lg">
            2.9.1 This TOU will continue in effect unless and until it is
            terminated by either party in accordance with this TOU through
            written communication over email.
          </p>
        </div>
        <div className="my-10">
          <h1 className="text-goodwork-navyblue text-2xl font-semibold leading-tight">
            GoodWork Terms – Prohibited Services List
          </h1>
          <p className="my-2 lg:text-lg">
            It is the Service Partner’s responsibility to ensure that they do
            not offer any prohibited services, as defined by applicable laws and
            elaborated below. This is a non-exhaustive list, and it can be
            updated from time to time when necessary.
          </p>
          <p className="my-2 mx-4">
            1. Violation of our Terms of Use Violation of this Prohibited
            Services Policy may subject the Service Partner to a range of
            adverse actions, including but not limited to any or all of the
            following:
          </p>
          <ul className="list-disc my-2 mx-16">
            <li>Suspension or deletion of GoodWork profile</li>
            <li>Legal actions</li>

            <li>Reduction of account privileges</li>
          </ul>
          <p className="my-2 mx-4">2. List of Prohibited Services</p>
          <ul className="list-disc my-2 mx-16">
            <li>Services involving any illegal products</li>
            <li>Services involving the use of any firearms</li>

            <li>Services involving any counterfeit currency</li>
            <li>
              Services that are generally considered to be sexual in nature
            </li>
            <li>Services including any food items hazardous to human health</li>

            <li>Services involving the destruction of any private property</li>
            <li>
              Services that involve trespassing into government-owned and/or
              private property
            </li>
            <li>Services that involve any stolen properties</li>
          </ul>
          <p className="my-2 lg:text-lg">
            If you have any questions about these terms, please message GoodWork
            on the GoodWork Facebook Messenger Page at Facebook.com/GoodWork.ph
          </p>
        </div>
        <div className="my-10">
          <h3 className="text-goodwork-navyblue text-lg font-normal leading-tight">
            Laundry Operations Guidelines
          </h3>
          <p className="my-2 lg:text-lg">
            Customer satisfaction is GoodWork’s first priority. In fact, we
            treat your laundry as if it were our own, however we still need to
            agree to some rules to ensure that there are no misunderstandings
            about GoodWork Laundry Services (referred to as &quot;we,&quot;
            &quot;us,&quot; &quot;our&quot;, or &quot;GoodWork Laundry&quot;).
            By using our service, you acknowledge and accept the following Terms
            and Conditions.
          </p>
          <p className="my-2 lg:text-lg">Wash-and-Fold Laundry Terms</p>
          <p className="my-2 lg:text-lg">
            1. Suitability for Laundering <br /> By using our service, you agree
            that your clothes are suitable to be washed in water, on a normal
            cycle, and dried using heat in a tumble dryer. We cannot be
            responsible for any damage to clothing that is not suitable for this
            standard laundering process. Similarly, we reserve the right to
            refuse to service items that we feel will be hazardous to our staff,
            such as items heavily soiled with human or animal waste. This is for
            the health and safety of our team.
          </p>
          <p className="my-2 lg:text-lg">
            2. Damaged Laundry <br /> We will do everything we can to avoid
            damaging your laundry. Unfortunately there are limitations to what
            we can do. For example, we do not promise to check your pockets to
            see if you have left anything in them. Therefore, we cannot be held
            responsible if something left in your laundry (like lipstick,
            chewing gum, or a pen) causes any damage. Similarly, if you call and
            tell us that you left your favorite bracelet, or anything else, in
            your pocket, we cannot guarantee that we will find or return it.
          </p>
          <p className="my-2 lg:text-lg">
            All laundering processes, regardless of how gentle, cause normal
            wear and tear on clothing. As a result, we cannot be responsible for
            any wear and tear of laundry, including loss of buttons, fading,
            fatiguing, holes, or abrasions. Similarly, we reserve the right to
            decline cleaning any particular piece of laundry if we think it will
            lead to trouble.
          </p>
          <p className="my-2 lg:text-lg">
            Cleaning and drying laundry also creates other risks. We do not
            individually examine every garment prior to placing it in the
            laundry. Therefore, if something is &quot;dry-clean only,&quot; or
            otherwise unsuitable for common washing and drying techniques,
            please do not include it in the laundry you give to us.
          </p>
          <p className="my-2 lg:text-lg">
            We wash all items together as our standard procedure. But if you
            divide your clothes into two separate bags before your pick-up, we
            can run two separate loads. This incurs a Separate Load Charge
            (presently at P125). Note that we do not separate clothes at the
            laundry shop; we ask that you do the separation before giving the
            clothes to our rider and take responsibility for what is in each
            load. Along the same lines, we cannot be held responsible for any
            bleeding of colors or dimensional changes (shrinking or stretching).
          </p>
          <p className="my-2 lg:text-lg">
            3. Lost Laundry <br /> We would love to be able to inventory every
            piece of laundry you give us. Unfortunately, it is cost-prohibitive
            for us to do so. As a result we cannot be held responsible for any
            lost laundry; we simply have no efficient way of verifying that we
            actually received any particular piece of laundry in the first
            place.
          </p>
          <p className="my-2 lg:text-lg">
            Rest assured though, we carefully track your clothes. For instance,
            we tag all our bundles with your name, and your clothes are never
            loose in our facility unless they are inside a machine, on the
            folding table, or in their own laundry cart waiting to be folded.
          </p>
          <p className="my-2 lg:text-lg">
            If Customers have concerns about any lost or damaged clothing, they
            must notify us within 36 hours of receiving returned clothes in
            order to receive support from GoodWork’s operations team.
          </p>
          <p className="my-2 lg:text-lg">
            4. Pick-up and Delivery <br /> Scheduling GoodWork Laundry provides
            pick-up and delivery service on motorcycles. There are, however,
            circumstances when we may be unable to use motorcycles to complete
            deliveries (like rain, or all of our delivery riders simultaneously
            having their motorcycles breaking down). Therefore, we reserve the
            right to pick-up and deliver your laundry using more conventional
            methods if necessary.
          </p>
          <p className="my-2 lg:text-lg">
            We will do our best to pick-up your laundry at the agreed upon time.
            We know that we won&apos;t have very many customers if we are late.
            That being said, we cannot be held accountable if we are late for
            unforeseen circumstances. Similarly, we hope that you will strive to
            be on-time for our deliveries. If you do miss a pick-up or delivery,
            we will try to coordinate an alternate time as soon as possible.{' '}
          </p>
          <p className="my-2 lg:text-lg">
            To prevent laundry errors, all services must be tied to an
            appointment. If we are coming to your residence for a delivery and
            you have additional dirty laundry that you would like to be picked
            up, please schedule an additional pickup online or through our app.{' '}
          </p>
          <p className="my-2 lg:text-lg">
            A No-Show is when we show up to your door, but you and your laundry
            are not around. In the case of a No-Show, we reserve the right to
            mark the pick up as cancelled.
          </p>
          <p className="my-2 lg:text-lg">
            5. Unattended Pick-up and Delivery <br /> If you request that we
            leave your laundry unattended (e.g., on your porch, in a hallway, or
            in your foyer) or with a third party (e.g., with a doorman or a
            neighbor), we are not responsible for your laundry before we have
            picked it up or after we have dropped it off. You also agree that
            our records of pick-up and drop-off times are true and accurate.
          </p>
          <p className="my-2 lg:text-lg">
            6. Miscellaneous <br /> As our business changes, we may want to
            modify some of the terms in these terms. Therefore, we encourage you
            to check back frequently to familiarize yourself with any changes.
          </p>

          <div className="my-10">
            <h3 className="text-goodwork-navyblue text-lg font-semibold leading-tight">
              Halloween Campaign Terms & Conditions
            </h3>
            <ol className="lg:text-lg list-decimal pl-5">
              <li className="my-2">
                GoodWork’s Halloween Sale will run from October 30-31.
              </li>
              <li className="my-2">
                The voucher code: GWTREAT20 should be used to be eligible for a
                20% OFF discount on ALL GoodWork services.
              </li>
              <li className="my-2">
                Only bookings submitted on October 30-31 with the voucher code
                are eligible to get the discount. Bookings made on those dates
                without the voucher code shall be charged the original price of
                the service.
              </li>
              <li className="my-2">
                Customers are allowed to select any date they want for the
                service.
              </li>
              <li className="my-2">
                Cancellation and rebooking of pending requests with the voucher
                discount is only allowed if rebooking was done on October 30-31.
              </li>
              <li className="my-2">
                Other discounts may not be used in conjunction with the
                GWTREAT20 discount. (for Senior Citizens, PWD)
              </li>
            </ol>
          </div>
          <p className="my-2 lg:text-lg">
            I HAVE READ THIS AGREEMENT AND AGREE TO ALL OF THE PROVISIONS
            CONTAINED ABOVE AND ANY REVISION THE SAME HEREAFTER. BY CLICKING THE
            “SIGN UP ” OR “CONNECT WITH FACEBOOK” BUTTON, I UNDERSTAND THAT I AM
            CREATING A DIGITAL SIGNATURE, WHICH I INTEND TO HAVE THE SAME FORCE
            AND EFFECT AS IF I HAD SIGNED MY NAME MANUALLY.
          </p>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default TermsAndConditionsPage;
